export default "__VITE_ASSET__YOfjTBZD__"